/**
 * Role-Based Route - SIMPLIFIED
 */

import { Navigate } from 'react-router-dom';
import { ROUTES } from './routeConfig';

const RoleBasedRoute = ({ children, allowedRoles }) => {
  // Check localStorage directly - simple and reliable
  const storedUser = localStorage.getItem('user');
  
  if (!storedUser) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  
  try {
    const user = JSON.parse(storedUser);
    
    if (!allowedRoles.includes(user.role)) {
      return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
    }
    
    return children;
  } catch {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
};

export default RoleBasedRoute;
